import {IPromotionPortalService} from "../services/IPromotionPortalService";

interface RetailerSubmitParams {
    retailerCode: string;
    promotionPortalService: IPromotionPortalService;
    setState: (
        state:
            | {
            isRetailerValid?: boolean;
            showLoader?: boolean;
            errorResponse?: string;
            successResponse?: string;
            retailerChecked?: boolean;
        }
            | ((
            prevState: any
        ) => {
            isRetailerValid?: boolean;
            showLoader?: boolean;
            errorResponse?: string;
            successResponse?: string;
            retailerChecked?: boolean;
        })
    ) => void;
}

export function handleRetailerSubmitLogic({
                                              retailerCode,
                                              promotionPortalService,
                                              setState
                                          }: RetailerSubmitParams): void {

    if (!retailerCode) {
        setState({isRetailerValid: false, retailerChecked: true});
        return;
    }

    setState({
        showLoader: true,
        errorResponse: "",
        successResponse: "",
    });

    promotionPortalService
        .checkRetailerByOutletCode(retailerCode)
        .subscribe(
            (isValid: boolean) => {
                setState({
                    isRetailerValid: isValid,
                    showLoader: false,
                    retailerChecked: !isValid
                });
            },
            () => {
                setState({
                    errorResponse:
                        "Failed to check retailer. Please try again later.",
                    showLoader: false,
                    retailerChecked: true
                });
            }
        );
}
